<template>
  <transition name="fade">
    <div class="overlay-confirm-box" v-if="visible">
      <div class="overlay-bg-confirm-box" @click="handle(false)"></div>
      <transition name="scale">
        <section class="overlay-confirm-box section-1-c-b" v-if="visible">
          <div class="sheet-1-c-b">
            <div class="confirm-box-pay">
              <div v-if="type !== 'alert'" @click.stop="handle(false)" class="custom-alert-close-button-notice"></div>
              <h1 v-if="data.title" class="confirm-box-title" >{{ data.title }}</h1>
              <p v-if="data.text" class="confirm-box-text" >{{ data.text }}</p>
              <input v-if="type === 'prompt'" v-model="promptValue" class="confirm-box-input" :placeholder="data.placeholder || ''" />
              <div v-if="error" class="error-text">{{ error }}</div>
              <div class="confirm-box-button-box">
                <div v-if="type !== 'alert'" class="confirm-box-cancel-button" @click.stop="handle(false)">
                  <a class="a-dialog-box-left" href="javascript:void(0)">{{ data.leftButton }}</a>
                </div>
                <div class="confirm-box-pay-button" @click.stop="handle(true)" :style="( data.rightButtonStyle ? data.rightButtonStyle : '' )">
                  <a class="a-dialog-box-right" href="javascript:void(0)">
                    <span v-if="loading">⏳</span>
                    <span v-else>{{ data.rightButton || 'OK' }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </transition>
    </div>
  </transition>
</template>
<script>
  export default {
    name: "DialogBox",
    data() {
      return {
        visible: false,
        data: {},
        resolver: null,
        type: 'confirm',
        promptValue: '',
        loading: false,
        error: ''
      }
    },
    computed: {
      typeClass() {
        return `dialog-${this.data.dialogType || 'default'}`
      }
    },
    methods: {
      open(data, type) {
        this.data = data
        this.type = type
        this.promptValue = data.default || ''
        this.visible = true

        document.body.style.position = 'fixed'

        return new Promise(resolve => {
          this.resolver = resolve
        })
      },
      async handle(result) {
        if (this.type === 'prompt' && result) {
          if (this.data.validate && !this.data.validate(this.promptValue)) {
            this.error = this.data.errorMessage || 'Invalid value'
            return
          }
        }
        this.error = '';
        this.loading = true;
        await new Promise(r => setTimeout(r, 300)) // fake loader
        this.visible = false;
        this.loading = false;
        document.body.style.position = '';       
  
        if (this.type === 'prompt' && result) {
          this.resolver && this.resolver(this.promptValue);
        } else {
          this.resolver && this.resolver(result);
        }
        this.resolver = null;
        this.data = {};
        this.promptValue = '';
      }
    }
  }
  </script>

<style scoped>

/* FADE ANIMÁCIA PRE OVERLAY */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* SCALE ANIMÁCIA PRE DIALOG */
.scale-enter-active {
  animation: scaleIn 0.3s ease-out;
}
.scale-leave-active {
  animation: scaleOut 0.2s ease-in forwards;
}

@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 0.5;
  }
}

@keyframes scaleOut {
  from {
    transform: scale(1);
    opacity: 0.5;
  }
  to {
    transform: scale(0.8);
    opacity: 0;
  }
}

.overlay-confirm-box {
  display: block;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.overlay-bg-confirm-box {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
}

.overlay-confirm-box .section-1-c-b {
  z-index: 1100;
  background-color: rgba(33, 41, 48, 0.5);
  -webkit-backdrop-filter: blur(5px); 
  backdrop-filter: blur(5px);
  position: absolute;
  width: 100vw;
  max-width: 100%;
}

.confirm-box-pay {
    width: max-content;
    min-width: 400px;
    height: auto;
    padding: 30px;
    background-color: white;
    border-radius: 15px;
  }
  

.confirm-box-title {
  font-size: 32px;
  font-family: 'LatoBlack';
  word-break: normal;
  max-width: 450px;
  margin-bottom: 0px;
  text-align: center;
  margin-bottom: 14px;
}

.confirm-box-text {
  font-size: 16px;
  font-family: 'LatoRegular';
  word-break: normal;
  max-width: 450px;
  text-align: center;
}

.confirm-box-button-box {
    text-align: right;
    margin-top: 28px;
    display: flex;
    align-items: right;
  
  }
  
  .confirm-box-cancel-button {
    color: #282731;
    text-decoration: none;
    font-family: 'LatoBold';
    background-color: rgb(255, 255, 255);
    border: solid 2px #282731;
    padding: 10px 15px 12px 15px;
    border-radius: 50px;
    width: 50%;
    transition: transform .2s;
    cursor: pointer;
    margin: auto;
    margin-right: 0px;
    text-align: center;
    font-size: 20px;
  }
  
  .confirm-box-pay-button {
    color: rgb(255, 255, 255);
    text-decoration: none;
    font-family: 'LatoBold';
    font-size: 20px !important;
    background-color: #009de6;
    border: solid 2px #009de6;
    padding: 10px 15px 12px 15px;
    border-radius: 50px;
    margin-left: 15px;
    width: 50%;
    transition: transform .2s;
    cursor: pointer;
    margin-right: 0px;
    text-align: center;
  
  }
  
  .confirm-box-button-box .confirm-box-cancel-button:hover {
    transform: scale(1.05);
  }
  
  .confirm-box-button-box .confirm-box-pay-button:hover {
    transform: scale(1.05);
    background-color: #4bbaed;
    border: solid 2px #4bbaed;
  }

.superActive {
  color: #009de6 !important;
}

.custom-alert-close-button-notice {
    margin-left: auto;
    cursor: pointer;
    top: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgb(231, 231, 231);
    background-image: url(https://data.pixcham.com/preview/cancel_black.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50%;

  }

  .overlay-confirm-box .sheet-1-c-b {
    position: relative;
    display: flex;
    height: 100%;
    align-items: center;justify-content: center;
  }

  .a-dialog-box-right {
    text-decoration: none; 
    color: #ffffff;
  }

  .a-dialog-box-left {
    text-decoration: none; 
    color: #282731;
  }

</style>
  